/** تبدیل مسیر فایل‌های آپلودی (لوگو، عکس) به آدرس کامل */
export function getFileUrl(path) {
  if (!path) return null;
  if (/^(https?:|blob:|data:)/i.test(path)) return path;

  const base =
    process.env.REACT_APP_API_BASE_URL?.replace(/\/api\/v1\/?$/, '') || '';

  if (!base) return path;
  return `${base}${path.startsWith('/') ? '' : '/'}${path}`;
}
